import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/NotFound.css";

function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="notFound">
      <div className="notFound__inner">
        <div className="notFound__card">
          <div className="notFound__code">404</div>

          <h1 className="notFound__title">
            {t("notFound.title")}
          </h1>

          <p className="notFound__text">
            {t("notFound.goBack")}{" "}
            <Link to="/" className="notFound__link">
              {t("notFound.homeLink")}
            </Link>
            .
          </p>

          <div className="notFound__actions">
            <Link to="/" className="homeButton homeButton--primary">
              {t("nav.home")}
            </Link>

            <Link to="/map" className="homeButton homeButton--secondary">
              {t("nav.map")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;